import { render, staticRenderFns } from "./AppModulesList.vue?vue&type=template&id=ba519c46&scoped=true"
import script from "./AppModulesList.vue?vue&type=script&lang=js"
export * from "./AppModulesList.vue?vue&type=script&lang=js"
import style0 from "./AppModulesList.vue?vue&type=style&index=0&id=ba519c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba519c46",
  null
  
)

export default component.exports